import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import TimeIcon from '../../../../assets/svg/time-zone.svg';
import inputSearch from '../../../../assets/img/input-search.png';
import { PermissionCheck } from '../../../component/permission-check';
import { DeployArea, RbacRoleObjectKey } from '../../../../model';
import { SvgIcon } from '../../../../components/svg-icon';
import { SvgIconName } from '../../../../components/svg-icon/model';
import { Button, Input, InputNumber, Select } from 'antd';
import classNames from 'classnames';
import getFormatMessage from '../../../../locales/get-format-message';
import { updateGameInfo } from '../../../../api';
import { IAPIGameItem } from '../../../../model/api-modules';
import { Dispatch } from 'redux';
import {
  GamesAction,
  ReduxGamesActionType,
  getGameList,
} from '../../../../store/modules/games';
import { messageSuccess } from '../../../../components/message';
import { getLocaleLanguage, LanguageType } from '../../../../lib';
import { saveTimeSetting } from '../../../../api/game/env';
import {
  IFrequencyDefinition,
  IGameEnvModel,
} from '../../../../model/api-modules/env';
import { getConfig } from '../../../../config';

interface ITimezoneData {
  value: string;
  label: string;
  cityName: string;
  utcOffset: string;
  countryCode?: string;
}
enum EditType {
  Day = 'day',
  Week = 'week',
  Mouth = 'mouth',
  TimeZone = 'timeZone',
}

interface IProps {
  readonly selectedGame: IAPIGameItem | undefined;
  readonly envList: ReadonlyArray<IGameEnvModel>;
}

enum TimeType {
  Natural = 'natural', // 自然周 自然月
  Custom = 'custom', // 自定义周 自定义月
}
enum CustomType {
  Astride = 'astride', // 跨周 跨月 跨日
  Inside = 'inside', // 本周 本月 当日
}

interface IOption {
  readonly label: string;
  readonly value: number;
  readonly disabled?: boolean;
}

export const TabTime = (props: IProps) => {
  const [allTimezones, setAllTimezones] = useState<ITimezoneData[]>([]);
  const [isEditTimeZone, setIsEditTimeZone] = useState<boolean>(false);
  const [currentSelectedTimezone, setCurrentSelectedTimezone] =
    useState<string>('');
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [filteredTimezones, setFilteredTimezones] = useState<ITimezoneData[]>(
    []
  );
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);

  const [isEditWeek, setIsEditWeek] = useState<boolean>(false);
  const [weekType, setWeekType] = useState<TimeType>(TimeType.Natural); // 自然周或自定义周
  const [weekCustomType, setWeekCustomType] = useState<CustomType>(
    CustomType.Inside
  ); // 是否跨周
  const [weekStartTime, setWeekStartTime] = useState<Record<string, number>>({
    week: 1,
    hour: 0,
    minute: 0,
    second: 0,
  }); // 周定义开始时间 默认周一 00:00
  const [weekEndTime, setWeekEndTime] = useState<Record<string, number>>({
    week: 7,
    hour: 23,
    minute: 59,
    second: 59,
  }); // 周定义结束时间 默认周日 23:59

  const [isEditMonth, setIsEditMonth] = useState<boolean>(false);
  const [mouthType, setMouthType] = useState<TimeType>(TimeType.Natural); // 自然月或自定义月
  const [mouthCustomType, setMouthCustomType] = useState<CustomType>(
    CustomType.Inside
  ); // 是否跨月
  const [mouthStartTime, setMouthStartTime] = useState<Record<string, number>>({
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
  }); // 月定义开始时间 默认1号 00:00
  const [mouthEndTime, setMouthEndTime] = useState<Record<string, number>>({
    day: 31,
    hour: 23,
    minute: 59,
    second: 59,
  }); // 月定义结束时间 默认31号 23:59

  const [isEditDay, setIsEditDay] = useState<boolean>(false);
  const [dayType, setDayType] = useState<TimeType>(TimeType.Natural); // 自然日或自定义日
  const [dayCustomType, setDayCustomType] = useState<CustomType>(
    CustomType.Inside
  ); // 是否跨日
  const [dayStartTime, setDayStartTime] = useState<Record<string, number>>({
    hour: 0,
    minute: 0,
    second: 0,
  }); // 日定义开始时间 默认当日 00:00
  const [dayEndTime, setDayEndTime] = useState<Record<string, number>>({
    hour: 23,
    minute: 59,
    second: 59,
  }); // 日定义结束时间 默认次日 00:00

  const deployArea: DeployArea = getConfig()?.deployArea;
  const isSingapore = deployArea === DeployArea.singapore;
  const defaultTimezone = isSingapore ? 'Europe/London' : 'Asia/Shanghai';
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const language = getLocaleLanguage();
  const gameExtensionField = JSON.parse(
    props.selectedGame?.gameExtensionField || '{}'
  );
  const gameDefinition = Object.assign(
    {},
    gameExtensionField.frequency_definition
  );

  const weekOptions: IOption[] = [
    {
      label: getFormatMessage('monday'),
      value: 1,
    },
    {
      label: getFormatMessage('tuesday'),
      value: 2,
    },
    {
      label: getFormatMessage('wednesday'),
      value: 3,
    },
    {
      label: getFormatMessage('thursday'),
      value: 4,
    },
    {
      label: getFormatMessage('friday'),
      value: 5,
    },
    {
      label: getFormatMessage('saturday'),
      value: 6,
    },
    {
      label: getFormatMessage('sunday'),
      value: 7,
    },
  ];

  const addZero = (num: number) => {
    return num < 10 ? String(num).padStart(2, '0') : num;
  };

  const generateArray = (start: number, end: number) => {
    const result = [];
    const step = start <= end ? 1 : -1;
    const length = Math.abs(end - start) + 1;
    for (let i = 0; i < length; i++) {
      result.push(start + i * step);
    }
    return result;
  };

  // const removeLeadingZero = (input: number | string): number => {
  //     const str = String(input);

  //     // 处理特殊情况：纯零 "000" -> 0
  //     if (/^0+$/.test(str)) {
  //         return 0;
  //     }

  //     // 去掉开头的零，但保留有效数字
  //     const removed = str.replace(/^0+/, '');

  //     // 转换为数字并返回
  //     return Number(removed);
  // };

  // 小写去空格
  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  useEffect(() => {
    const timezones: string[] = moment.tz.names();
    const processedTimezones: ITimezoneData[] = [];

    timezones.forEach((tz: string) => {
      const offset: string = moment().tz(tz).format('Z');
      const parts: string[] = tz.split('/');
      const region: string = parts[0];
      let cityName: string = parts[parts.length - 1].replace(/_/g, ' ');

      cityName = cityName
        .split(' ')
        .map(
          (word: string) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
      // 生成格式为 "(UTC+08:00)  Shanghai" 的标签
      const displayLabel = `(UTC${offset}) ${cityName}`;

      const timezoneItem: ITimezoneData = {
        value: tz,
        label: displayLabel, // 使用新的显示格式
        cityName,
        utcOffset: offset,
        countryCode: region,
      };
      const timeZoneIt = processedTimezones.find(
        (item) =>
          toLowerCaseAndRemoveSpaces(item.label) ===
          toLowerCaseAndRemoveSpaces(displayLabel)
      );
      if (!timeZoneIt) {
        processedTimezones.push(timezoneItem);
      }
    });

    // 按 UTC 偏移量排序
    processedTimezones.sort((a: ITimezoneData, b: ITimezoneData) => {
      const offsetA: number = parseInt(a.utcOffset.replace(':', ''));
      const offsetB: number = parseInt(b.utcOffset.replace(':', ''));
      return offsetA - offsetB;
    });

    setAllTimezones(processedTimezones);
  }, []);

  const initAppConfig = () => {
    setCurrentSelectedTimezone(gameDefinition?.timeZone || defaultTimezone);

    setDayType(gameDefinition?.dayDefinition?.dayType || TimeType.Natural);
    setDayCustomType(
      gameDefinition?.dayDefinition?.customType || CustomType.Inside
    );
    setDayStartTime(
      gameDefinition?.dayDefinition?.startTime || {
        hour: 0,
        minute: 0,
        second: 0,
      }
    );
    setDayEndTime(
      gameDefinition?.dayDefinition?.endTime || {
        hour: 23,
        minute: 59,
        second: 59,
      }
    );

    setWeekType(gameDefinition?.weekDefinition?.weekType || TimeType.Natural);
    setWeekCustomType(
      gameDefinition?.weekDefinition?.customType || CustomType.Inside
    );
    setWeekStartTime(
      gameDefinition?.weekDefinition?.startTime || {
        week: 1,
        hour: 0,
        minute: 0,
        second: 0,
      }
    );
    setWeekEndTime(
      gameDefinition?.weekDefinition?.endTime || {
        week: 7,
        hour: 23,
        minute: 59,
        second: 59,
      }
    );

    setMouthType(
      gameDefinition?.monthDefinition?.monthType || TimeType.Natural
    );
    setMouthCustomType(
      gameDefinition?.monthDefinition?.customType || CustomType.Inside
    );
    setMouthStartTime(
      gameDefinition?.monthDefinition?.startTime || {
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
      }
    );
    setMouthEndTime(
      gameDefinition?.monthDefinition?.endTime || {
        day: 31,
        hour: 23,
        minute: 59,
        second: 59,
      }
    );
  };

  useEffect(() => {
    // 初始化配置
    initAppConfig();
  }, [props.selectedGame]);

  const handleEditClick = (key: EditType) => {
    if (key === EditType.TimeZone) {
      setIsEditTimeZone(true);
    } else if (key === EditType.Week) {
      setIsEditWeek(true);
    } else if (key === EditType.Mouth) {
      setIsEditMonth(true);
    } else if (key === EditType.Day) {
      setIsEditDay(true);
    }
  };

  const handleEditCancel = (key: EditType) => {
    if (key === EditType.TimeZone) {
      setIsEditTimeZone(false);
      setSearchKeyword('');
    } else if (key === EditType.Week) {
      setIsEditWeek(false);
    } else if (key === EditType.Mouth) {
      setIsEditMonth(false);
    } else if (key === EditType.Day) {
      setIsEditDay(false);
    }
    initAppConfig();
  };

  const timeSetting = async (
    gameId: string,
    envId: number,
    envGuid: string,
    frequency_definition: IFrequencyDefinition
  ) => {
    return await saveTimeSetting({
      game_id: gameId,
      env_id: envGuid,
      gameID: gameId,
      envID: envId,
      frequency_definition,
    });
  };

  const savaTime = async (frequency_definition: IFrequencyDefinition) => {
    try {
      const results = await Promise.all(
        props.envList.map((item) =>
          timeSetting(item.GameID, item.id, item.Guid, frequency_definition)
        )
      );
      return results;
    } catch (error) {
      console.error('errpr:', error);
      throw error;
    }
  };

  const handleEditOk = async (key: EditType) => {
    console.log(key);
    if (props.selectedGame) {
      const extensionField = gameExtensionField
        ? Object.assign({}, gameExtensionField)
        : {};
      const definitionList = Object.assign(
        {},
        extensionField.frequency_definition
      );
      definitionList.timeZone = currentSelectedTimezone;
      definitionList.weekDefinition = {
        weekType,
        startTime: weekStartTime,
        endTime: weekEndTime,
        customType: weekCustomType,
      };
      definitionList.monthDefinition = {
        monthType: mouthType,
        startTime: mouthStartTime,
        endTime: mouthEndTime,
        customType: mouthCustomType,
      };
      definitionList.dayDefinition = {
        dayType,
        startTime: dayStartTime,
        endTime: dayEndTime,
        customType: dayCustomType,
      };
      definitionList.timeOffset =
        moment().tz(currentSelectedTimezone).utcOffset() / 60;
      savaTime(definitionList).then((finalResults) => {
        if (!finalResults) {
          return;
        }
      });
      const res = await updateGameInfo({
        gameID: props.selectedGame.gameID,
        extensionField: {
          ...extensionField,
          frequency_definition: definitionList,
        },
      });
      setIsEditTimeZone(false);
      setIsEditWeek(false);
      setIsEditMonth(false);
      setIsEditDay(false);
      if (res) {
        gamesDispatch({
          type: ReduxGamesActionType.SELECT_GAME,
          result: { ...props.selectedGame, extensionField },
        });
        // @ts-ignore
        await getGameList(gamesDispatch)();
        messageSuccess(getFormatMessage('success'));
      }
    }
  };

  useEffect(() => {
    if (!searchKeyword.trim()) {
      setFilteredTimezones(allTimezones);
      return;
    }

    const filtered = allTimezones.filter((tz: ITimezoneData) => {
      const keyword = searchKeyword.toLowerCase();
      return (
        tz.cityName.toLowerCase().includes(keyword) ||
        tz.label.toLowerCase().includes(keyword) ||
        tz.value.toLowerCase().includes(keyword) ||
        tz.utcOffset.toLowerCase().includes(keyword)
      );
    });

    setFilteredTimezones(filtered);
  }, [searchKeyword, allTimezones]);

  const handleTimezoneSelect = (timezoneValue: string): void => {
    setCurrentSelectedTimezone(timezoneValue);
  };

  const renderTimezoneOption = (tz: ITimezoneData): JSX.Element => (
    <div
      key={tz.value}
      onClick={() => handleTimezoneSelect(tz.value)}
      onMouseEnter={(e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.backgroundColor = '#f8f9fa';
      }}
      onMouseLeave={(e: React.MouseEvent<HTMLDivElement>) => {
        e.currentTarget.style.backgroundColor = 'white';
      }}
      style={{
        color: tz.value === currentSelectedTimezone ? '#5764F1' : '#222222',
      }}
      className="switch-choice-body-item"
    >
      <span>{tz.label}</span>
    </div>
  );

  const renderTimeText = () => {
    const selectedTimezone = gameDefinition?.timeZone || defaultTimezone;
    const current: ITimezoneData | undefined = allTimezones.find(
      (tz: ITimezoneData) => tz.value === selectedTimezone
    );
    return (
      <div style={{ display: 'flex' }}>
        <img src={TimeIcon} style={{ width: 16, height: 16 }} />
        <div
          style={{
            fontSize: '14px',
            color: '#1D2129',
            marginTop: '-3px',
            marginLeft: '4px',
          }}
        >
          {current?.label || ''}
        </div>
        <PermissionCheck permissionKey={RbacRoleObjectKey.EditSystemSettings}>
          <Button
            type="link"
            onClick={() => handleEditClick(EditType.TimeZone)}
            disabled={isEditTimeZone || isEditWeek || isEditMonth || isEditDay}
          >
            <SvgIcon
              icon={SvgIconName.StudioNameEdit}
              className="icon-edit action-icon pointer m-l"
            />
          </Button>
        </PermissionCheck>
      </div>
    );
  };
  const renderDayText = () => {
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ fontSize: '14px', color: '#1D2129', marginTop: '-3px' }}>
          <span>{getFormatMessage('current_day_empyt')}</span>
          &nbsp;
          <span>{addZero(dayStartTime.hour)}</span>
          <span>:</span>
          <span>{addZero(dayStartTime.minute)}</span>
          <span>:</span>
          <span>{addZero(dayStartTime.second)}</span>
          <span style={{ margin: '0 6px' }}>~</span>
          <span>
            {dayType === TimeType.Custom && dayCustomType === CustomType.Astride
              ? getFormatMessage('day_next')
              : getFormatMessage('current_day_empyt')}
          </span>
          &nbsp;
          <span>{addZero(dayEndTime.hour)}</span>
          <span>:</span>
          <span>{addZero(dayEndTime.minute)}</span>
          <span>:</span>
          <span>{addZero(dayEndTime.second)}</span>
        </div>
        <PermissionCheck permissionKey={RbacRoleObjectKey.EditSystemSettings}>
          <Button
            type="link"
            onClick={() => handleEditClick(EditType.Day)}
            disabled={isEditTimeZone || isEditWeek || isEditMonth || isEditDay}
          >
            <SvgIcon
              icon={SvgIconName.StudioNameEdit}
              className="icon-edit action-icon pointer m-l"
            />
          </Button>
        </PermissionCheck>
      </div>
    );
  };
  const renderWeekText = () => {
    const startWeek =
      weekOptions.find((item) => item.value === weekStartTime.week)?.label ||
      '';
    const endWeek =
      weekOptions.find((item) => item.value === weekEndTime.week)?.label || '';
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ fontSize: '14px', color: '#1D2129', marginTop: '-3px' }}>
          <span>{language === LanguageType.zh_CN ? '每' : ''}</span>
          <span>{startWeek}&nbsp;</span>
          <span>{addZero(weekStartTime.hour)}</span>
          <span>:</span>
          <span>{addZero(weekStartTime.minute)}</span>
          <span>:</span>
          <span>{addZero(weekStartTime.second)}</span>
          <span style={{ margin: '0 6px' }}>~</span>
          <span>
            {weekType === TimeType.Custom &&
            weekCustomType === CustomType.Astride
              ? getFormatMessage('next_week')
              : getFormatMessage('current_week_empyt')}
          </span>
          <span>{endWeek}&nbsp;</span>
          <span>{addZero(weekEndTime.hour)}</span>
          <span>:</span>
          <span>{addZero(weekEndTime.minute)}</span>
          <span>:</span>
          <span>{addZero(weekEndTime.second)}</span>
        </div>
        <PermissionCheck permissionKey={RbacRoleObjectKey.EditSystemSettings}>
          <Button
            type="link"
            onClick={() => handleEditClick(EditType.Week)}
            disabled={isEditTimeZone || isEditWeek || isEditMonth || isEditDay}
          >
            <SvgIcon
              icon={SvgIconName.StudioNameEdit}
              className="icon-edit action-icon pointer m-l"
            />
          </Button>
        </PermissionCheck>
      </div>
    );
  };

  const renderMouthText = () => {
    const startMouth =
      mouthOptions.find((item) => item.value === mouthStartTime.day)?.label ||
      '';
    const endMouth =
      mouthOptions.find((item) => item.value === mouthEndTime.day)?.label || '';
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ fontSize: '14px', color: '#1D2129', marginTop: '-3px' }}>
          <span>{language === LanguageType.zh_CN ? '每月' : ''}</span>
          <span>{startMouth}&nbsp;</span>
          <span>{addZero(mouthStartTime.hour)}</span>
          <span>:</span>
          <span>{addZero(mouthStartTime.minute)}</span>
          <span>:</span>
          <span>{addZero(mouthStartTime.second)}</span>
          <span style={{ margin: '0 6px' }}>~</span>
          <span>
            {mouthType === TimeType.Custom &&
            mouthCustomType === CustomType.Astride
              ? getFormatMessage('time_month_next')
              : getFormatMessage('time_month_current')}
          </span>
          <span>{endMouth}&nbsp;</span>
          <span>{addZero(mouthEndTime.hour)}</span>
          <span>:</span>
          <span>{addZero(mouthEndTime.minute)}</span>
          <span>:</span>
          <span>{addZero(mouthEndTime.second)}</span>
        </div>
        <PermissionCheck permissionKey={RbacRoleObjectKey.EditSystemSettings}>
          <Button
            type="link"
            onClick={() => handleEditClick(EditType.Mouth)}
            disabled={isEditTimeZone || isEditWeek || isEditMonth || isEditDay}
          >
            <SvgIcon
              icon={SvgIconName.StudioNameEdit}
              className="icon-edit action-icon pointer m-l"
            />
          </Button>
        </PermissionCheck>
      </div>
    );
  };

  const handleDropdownVisibleChange = (visible: boolean) => {
    setDropdownVisible(visible);
    if (!visible) {
      // 下拉框关闭时清空搜索
      setSearchKeyword('');
    }
  };

  const dropdownRender = () => {
    return (
      <div className="tab-time-zone-select-box">
        <div className="switch-choice-search">
          <Input
            type=""
            placeholder="请输入城市"
            value={searchKeyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchKeyword(e.target.value)
            }
            style={{
              borderRadius: '2px',
              fontSize: '14px',
            }}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            className="search-input"
            prefix={<img src={inputSearch} />}
          />
        </div>
        <div className="switch-choice-body">
          {filteredTimezones.map(renderTimezoneOption)}
          {filteredTimezones.length === 0 && (
            <div
              style={{
                padding: '20px',
                textAlign: 'center',
                color: '#999',
                fontSize: '14px',
              }}
            >
              {getFormatMessage('no_search_result')}
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleDayTypeChange = (value: TimeType) => {
    setDayType(value);
    setDayStartTime({ hour: 0, minute: 0, second: 0 });
    setDayEndTime({ hour: 23, minute: 59, second: 59 });
    setDayCustomType(CustomType.Inside);
  };

  const handleDayCustomTypeChange = (value: CustomType) => {
    setDayCustomType(value);
    setDayStartTime({ hour: 0, minute: 0, second: 0 });
    if (value === CustomType.Astride) {
      setDayEndTime({ hour: 0, minute: 0, second: 0 });
    } else {
      setDayEndTime({ hour: 23, minute: 59, second: 59 });
    }
  };

  const handleWeekTypeChange = (value: TimeType) => {
    setWeekType(value);
    setWeekStartTime({ week: 1, hour: 0, minute: 0, second: 0 });
    setWeekEndTime({ week: 7, hour: 23, minute: 59, second: 59 });
    setWeekCustomType(CustomType.Inside);
  };

  const handleWeekCustomTypeChange = (value: CustomType) => {
    setWeekCustomType(value);
    setWeekStartTime({ week: 1, hour: 0, minute: 0, second: 0 });
    if (value === CustomType.Astride) {
      setWeekEndTime({ week: 1, hour: 0, minute: 0, second: 0 });
    } else {
      setWeekEndTime({ week: 7, hour: 23, minute: 59, second: 59 });
    }
  };

  const handleMouthTypeChange = (value: TimeType) => {
    setMouthType(value);
    setMouthStartTime({ day: 1, hour: 0, minute: 0, second: 0 });
    setMouthEndTime({ day: 31, hour: 23, minute: 59, second: 59 });
    setMouthCustomType(CustomType.Inside);
  };

  const handleMouthCustomTypeChange = (value: CustomType) => {
    setMouthCustomType(value);
    setMouthStartTime({ day: 1, hour: 0, minute: 0, second: 0 });
    if (value === CustomType.Astride) {
      setMouthEndTime({ day: 1, hour: 0, minute: 0, second: 0 });
    } else {
      setMouthEndTime({ day: 31, hour: 23, minute: 59, second: 59 });
    }
  };

  const getHourMinNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (dayCustomType === CustomType.Astride) {
          if (
            dayStartTime.minute < dayEndTime.minute ||
            (dayStartTime.minute === dayEndTime.minute &&
              dayStartTime.second < dayEndTime.second)
          ) {
            return dayEndTime.hour + 1;
          }
          return dayEndTime.hour;
        }
        return 0;
      }
      if (time === 'end') {
        if (dayCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          dayStartTime.minute > dayEndTime.minute ||
          (dayStartTime.minute === dayEndTime.minute &&
            dayStartTime.second >= dayEndTime.second)
        ) {
          return dayStartTime.hour + 1;
        }
        return dayStartTime.hour;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week
        ) {
          if (
            weekStartTime.minute < weekEndTime.minute ||
            (weekStartTime.minute === weekEndTime.minute &&
              weekStartTime.second < weekEndTime.second)
          ) {
            return weekEndTime.hour + 1;
          }
          return weekEndTime.hour;
        }
        return 0;
      }
      if (time === 'end') {
        if (weekCustomType === CustomType.Astride) {
          return 0;
        }
        if (weekStartTime.week !== weekEndTime.week) {
          return 0;
        }
        if (
          weekStartTime.minute > weekEndTime.minute ||
          (weekStartTime.minute === weekEndTime.minute &&
            weekStartTime.second >= weekEndTime.second)
        ) {
          return weekStartTime.hour + 1;
        }
        return weekStartTime.hour;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day
        ) {
          if (
            mouthStartTime.minute < mouthEndTime.minute ||
            (mouthStartTime.minute === mouthEndTime.minute &&
              mouthStartTime.second < mouthEndTime.second)
          ) {
            return mouthEndTime.hour + 1;
          }
          return mouthEndTime.hour;
        }
        return 0;
      }
      if (time === 'end') {
        if (mouthCustomType === CustomType.Astride) {
          return 0;
        }
        if (mouthStartTime.day !== mouthEndTime.day) {
          return 0;
        }
        if (
          mouthStartTime.minute > mouthEndTime.minute ||
          (mouthStartTime.minute === mouthEndTime.minute &&
            mouthStartTime.second >= mouthEndTime.second)
        ) {
          return mouthStartTime.hour + 1;
        }
        return mouthStartTime.hour;
      }
    }
  };
  const getHourMaxNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (dayCustomType === CustomType.Astride) {
          return 23;
        }
        if (
          dayStartTime.minute > dayEndTime.minute ||
          (dayStartTime.minute === dayEndTime.minute &&
            dayStartTime.second >= dayEndTime.second)
        ) {
          return dayEndTime.hour - 1;
        }
        return dayEndTime.hour;
      }
      if (time === 'end') {
        if (dayCustomType === CustomType.Astride) {
          if (
            dayStartTime.minute < dayEndTime.minute ||
            (dayStartTime.minute === dayEndTime.minute &&
              dayStartTime.second < dayEndTime.second)
          ) {
            return dayStartTime.hour - 1;
          }
          return dayStartTime.hour;
        }
        return 23;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (weekCustomType === CustomType.Astride) {
          return 23;
        }
        if (weekStartTime.week !== weekEndTime.week) {
          return 23;
        }
        if (
          weekStartTime.minute > weekEndTime.minute ||
          (weekStartTime.minute === weekEndTime.minute &&
            weekStartTime.second >= weekEndTime.second)
        ) {
          return weekEndTime.hour - 1;
        }
        return weekEndTime.hour;
      }
      if (time === 'end') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week
        ) {
          if (
            weekStartTime.minute < weekEndTime.minute ||
            (weekStartTime.minute === weekEndTime.minute &&
              weekStartTime.second < weekEndTime.second)
          ) {
            return weekStartTime.hour - 1;
          }
          return weekStartTime.hour;
        }
        return 23;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (mouthCustomType === CustomType.Astride) {
          return 23;
        }
        if (mouthStartTime.day !== mouthEndTime.day) {
          return 23;
        }
        if (
          mouthStartTime.minute > mouthEndTime.minute ||
          (mouthStartTime.minute === mouthEndTime.minute &&
            mouthStartTime.second >= mouthEndTime.second)
        ) {
          return mouthEndTime.hour - 1;
        }
        return mouthEndTime.hour;
      }
      if (time === 'end') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day
        ) {
          if (
            mouthStartTime.minute < mouthEndTime.minute ||
            (mouthStartTime.minute === mouthEndTime.minute &&
              mouthStartTime.second < mouthEndTime.second)
          ) {
            return mouthStartTime.hour - 1;
          }
          return mouthStartTime.hour;
        }
        return 23;
      }
    }
  };
  const getMinuteMinNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (
          dayCustomType === CustomType.Astride &&
          dayStartTime.hour === dayEndTime.hour
        ) {
          if (dayStartTime.second < dayEndTime.second) {
            return dayEndTime.minute + 1;
          }
          return dayEndTime.minute;
        }
        return 0;
      }
      if (time === 'end') {
        if (dayCustomType === CustomType.Astride) {
          return 0;
        }
        if (dayStartTime.hour === dayEndTime.hour) {
          if (dayStartTime.second >= dayEndTime.second) {
            return dayStartTime.minute + 1;
          }
          return dayStartTime.minute;
        }
        return 0;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour
        ) {
          if (weekStartTime.second < weekEndTime.second) {
            return weekEndTime.minute + 1;
          }
          return weekEndTime.minute;
        }
        return 0;
      }
      if (time === 'end') {
        if (weekCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour
        ) {
          if (weekStartTime.second >= weekEndTime.second) {
            return weekStartTime.minute + 1;
          }
          return weekStartTime.minute;
        }
        return 0;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour
        ) {
          if (mouthStartTime.second < mouthEndTime.second) {
            return mouthEndTime.minute + 1;
          }
          return mouthEndTime.minute;
        }
        return 0;
      }
      if (time === 'end') {
        if (mouthCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour
        ) {
          if (mouthStartTime.second > mouthEndTime.second) {
            return mouthStartTime.minute + 1;
          }
          return mouthStartTime.minute;
        }
        return 0;
      }
    }
  };
  const getMinuteMaxNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (dayCustomType === CustomType.Astride) {
          return 59;
        }
        if (dayStartTime.hour === dayEndTime.hour) {
          if (dayStartTime.second >= dayEndTime.second) {
            return dayEndTime.minute - 1;
          }
          return dayEndTime.minute;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          dayCustomType === CustomType.Astride &&
          dayStartTime.hour === dayEndTime.hour
        ) {
          if (dayStartTime.second < dayEndTime.second) {
            return dayStartTime.minute - 1;
          }
          return dayStartTime.minute;
        }
        return 59;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (weekCustomType === CustomType.Astride) {
          return 59;
        }
        if (
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour
        ) {
          if (weekStartTime.second >= weekEndTime.second) {
            return weekEndTime.minute - 1;
          }
          return weekEndTime.minute;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour
        ) {
          if (weekStartTime.second < weekEndTime.second) {
            return weekStartTime.minute - 1;
          }
          return weekStartTime.minute;
        }
        return 59;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (mouthCustomType === CustomType.Astride) {
          return 59;
        }
        if (
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour
        ) {
          if (mouthStartTime.second >= mouthEndTime.second) {
            return mouthEndTime.minute - 1;
          }
          return mouthEndTime.minute;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour
        ) {
          if (mouthStartTime.second < mouthEndTime.second) {
            return mouthStartTime.minute - 1;
          }
          return mouthStartTime.minute;
        }
        return 59;
      }
    }
  };

  const getSecondMinNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (
          dayCustomType === CustomType.Astride &&
          dayStartTime.hour === dayStartTime.hour &&
          dayStartTime.minute === dayEndTime.minute
        ) {
          return dayEndTime.second;
        }
        return 0;
      }
      if (time === 'end') {
        if (dayCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          dayStartTime.hour === dayEndTime.hour &&
          dayStartTime.minute === dayEndTime.minute
        ) {
          return dayStartTime.second + 1;
        }
        return 0;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute === weekEndTime.minute
        ) {
          return weekEndTime.second;
        }
        return 0;
      }
      if (time === 'end') {
        if (weekCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute === weekEndTime.minute
        ) {
          return weekStartTime.second + 1;
        }
        return 0;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute === mouthEndTime.minute
        ) {
          return mouthEndTime.second;
        }
        return 0;
      }
      if (time === 'end') {
        if (mouthCustomType === CustomType.Astride) {
          return 0;
        }
        if (
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute === mouthEndTime.minute
        ) {
          return mouthStartTime.second + 1;
        }
        return 0;
      }
    }
  };

  const getSecondMaxNum = (type: string, time: string) => {
    if (type === 'day') {
      if (time === 'start') {
        if (dayCustomType === CustomType.Astride) {
          return 59;
        }
        if (
          dayStartTime.hour === dayEndTime.hour &&
          dayStartTime.minute === dayEndTime.minute
        ) {
          return dayEndTime.second - 1;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          dayCustomType === CustomType.Astride &&
          dayStartTime.hour === dayEndTime.hour &&
          dayStartTime.minute === dayEndTime.minute
        ) {
          return dayStartTime.second;
        }
        return 59;
      }
    } else if (type === 'week') {
      if (time === 'start') {
        if (weekCustomType === CustomType.Astride) {
          return 59;
        }
        if (
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute === weekEndTime.minute
        ) {
          return weekEndTime.second - 1;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          weekCustomType === CustomType.Astride &&
          weekStartTime.week === weekEndTime.week &&
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute === weekEndTime.minute
        ) {
          return weekStartTime.second;
        }
        return 59;
      }
    } else if (type === 'mouth') {
      if (time === 'start') {
        if (mouthCustomType === CustomType.Astride) {
          return 59;
        }
        if (
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute === mouthEndTime.minute
        ) {
          return mouthEndTime.second - 1;
        }
        return 59;
      }
      if (time === 'end') {
        if (
          mouthCustomType === CustomType.Astride &&
          mouthStartTime.day === mouthEndTime.day &&
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute === mouthEndTime.minute
        ) {
          return mouthStartTime.second;
        }
        return 59;
      }
    }
  };

  // 格式化显示：个位数补零
  const formatter = (val: number | undefined) => {
    if (!val) val = 0;
    const num = parseInt(val.toString(), 10);
    if (isNaN(num)) return '';
    return num < 10 ? `0${num}` : `${num}`;
  };

  const weekStartDisabled = (value: number) => {
    if (weekCustomType === CustomType.Inside) {
      if (value > weekEndTime.week) {
        return true;
      }
      if (value === weekEndTime.week) {
        if (weekStartTime.hour > weekEndTime.hour) {
          return true;
        }
        if (
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute > weekEndTime.minute
        ) {
          return true;
        }
      }
    } else {
      if (value < weekEndTime.week) {
        return true;
      }
      if (value === weekEndTime.week) {
        if (weekStartTime.hour < weekEndTime.hour) {
          return true;
        }
        if (
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute < weekEndTime.minute
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const weekEndDisabled = (value: number) => {
    if (weekCustomType === CustomType.Inside) {
      if (value < weekStartTime.week) {
        return true;
      }
      if (value === weekStartTime.week) {
        if (weekStartTime.hour > weekEndTime.hour) {
          return true;
        }
        if (
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute > weekEndTime.minute
        ) {
          return true;
        }
      }
    } else {
      if (value > weekStartTime.week) {
        return true;
      }
      if (value === weekStartTime.week) {
        if (weekStartTime.hour < weekEndTime.hour) {
          return true;
        }
        if (
          weekStartTime.hour === weekEndTime.hour &&
          weekStartTime.minute < weekEndTime.minute
        ) {
          return true;
        }
      }
    }
    return false;
  };
  const mouthStartDisabled = (value: number) => {
    if (mouthCustomType === CustomType.Inside) {
      if (value > mouthEndTime.day) {
        return true;
      }
      if (value === mouthEndTime.day) {
        if (mouthStartTime.hour > mouthEndTime.hour) {
          return true;
        }
        if (
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute > mouthEndTime.minute
        ) {
          return true;
        }
      }
    } else {
      if (value < mouthEndTime.day) {
        return true;
      }
      if (value === mouthEndTime.day) {
        if (mouthStartTime.hour < mouthEndTime.hour) {
          return true;
        }
        if (
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute < mouthEndTime.minute
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const mouthEndDisabled = (value: number) => {
    if (mouthCustomType === CustomType.Inside) {
      if (value < mouthStartTime.day) {
        return true;
      }
      if (value === mouthStartTime.day) {
        if (mouthStartTime.hour > mouthEndTime.hour) {
          return true;
        }
        if (
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute > mouthEndTime.minute
        ) {
          return true;
        }
      }
    } else {
      if (value > mouthStartTime.day) {
        return true;
      }
      if (value === mouthStartTime.day) {
        if (mouthStartTime.hour < mouthEndTime.hour) {
          return true;
        }
        if (
          mouthStartTime.hour === mouthEndTime.hour &&
          mouthStartTime.minute < mouthEndTime.minute
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const mouthOptions: IOption[] = generateArray(1, 31).map((item) => {
    return {
      label: `${item}${getFormatMessage('definition_st')}`,
      value: item,
    };
  });

  return (
    <div className="tab-time">
      <div className="tab-time-title">
        {getFormatMessage('game_time_setting')}
      </div>
      <div
        className={classNames(
          'tab-time-zone',
          isEditDay ? 'tab-time-zone-edit' : ''
        )}
      >
        <div className="tab-time-zone-title">
          <div>{getFormatMessage('daily_definition')}</div>
          {isEditDay && (
            <div className="tab-time-zone-btn">
              <div
                className="tab-time-zone-save"
                onClick={() => handleEditOk(EditType.Day)}
              >
                {getFormatMessage('save')}
              </div>
              <div
                className="tab-time-zone-cancel"
                onClick={() => handleEditCancel(EditType.Day)}
              >
                {getFormatMessage('cancel')}
              </div>
            </div>
          )}
        </div>
        {isEditDay ? (
          <div className="time-week-box">
            <Select
              value={dayType}
              style={{ width: 140, marginRight: 20 }}
              onChange={handleDayTypeChange}
            >
              <Select.Option value={TimeType.Natural}>
                {getFormatMessage('calendar_day')}
              </Select.Option>
              <Select.Option value={TimeType.Custom}>
                {getFormatMessage('custom_day')}
              </Select.Option>
            </Select>

            {dayType === TimeType.Custom && (
              <Select
                value={dayCustomType}
                style={{ width: 120, marginRight: 20 }}
                onChange={handleDayCustomTypeChange}
              >
                <Select.Option value={CustomType.Inside}>
                  {getFormatMessage('current_day')}
                </Select.Option>
                <Select.Option value={CustomType.Astride}>
                  {getFormatMessage('cross_day')}
                </Select.Option>
              </Select>
            )}

            <span className="time-week-label">
              {getFormatMessage('current_day_empyt')}
            </span>
            <InputNumber
              min={getHourMinNum('day', 'start')}
              max={getHourMaxNum('day', 'start')}
              formatter={formatter}
              value={dayStartTime.hour}
              onChange={(value) =>
                setDayStartTime({ ...dayStartTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('day', 'start')}
              max={getMinuteMaxNum('day', 'start')}
              formatter={formatter}
              value={dayStartTime.minute}
              onChange={(value) =>
                setDayStartTime({ ...dayStartTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('day', 'start')}
              max={getSecondMaxNum('day', 'start')}
              formatter={formatter}
              value={dayStartTime.second}
              onChange={(value) =>
                setDayStartTime({ ...dayStartTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />

            <span className="time-week-time-label" style={{ margin: '0 8px' }}>
              {' '}
              -{' '}
            </span>

            <span className="time-week-label" style={{ marginLeft: 0 }}>
              {getFormatMessage(
                dayType === TimeType.Custom &&
                  dayCustomType === CustomType.Astride
                  ? 'day_next'
                  : 'current_day_empyt'
              )}
            </span>
            <InputNumber
              min={getHourMinNum('day', 'end')}
              max={getHourMaxNum('day', 'end')}
              formatter={formatter}
              value={dayEndTime.hour}
              onChange={(value) =>
                setDayEndTime({ ...dayEndTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('day', 'end')}
              max={getMinuteMaxNum('day', 'end')}
              formatter={formatter}
              value={dayEndTime.minute}
              onChange={(value) =>
                setDayEndTime({ ...dayEndTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('day', 'end')}
              max={getSecondMaxNum('day', 'end')}
              formatter={formatter}
              value={dayEndTime.second}
              onChange={(value) =>
                setDayEndTime({ ...dayEndTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />
          </div>
        ) : (
          <div className="tab-time-zone-box">{renderDayText()}</div>
        )}
      </div>
      <div
        className={classNames(
          'tab-time-zone',
          isEditWeek ? 'tab-time-zone-edit' : ''
        )}
      >
        <div className="tab-time-zone-title">
          <div>{getFormatMessage('weekly_definition')}</div>
          {isEditWeek && (
            <div className="tab-time-zone-btn">
              <div
                className="tab-time-zone-save"
                onClick={() => handleEditOk(EditType.Week)}
              >
                {getFormatMessage('save')}
              </div>
              <div
                className="tab-time-zone-cancel"
                onClick={() => handleEditCancel(EditType.Week)}
              >
                {getFormatMessage('cancel')}
              </div>
            </div>
          )}
        </div>
        {isEditWeek ? (
          <div className="time-week-box">
            <Select
              value={weekType}
              style={{ width: 140, marginRight: 20 }}
              onChange={handleWeekTypeChange}
            >
              <Select.Option value={TimeType.Natural}>
                {getFormatMessage('calendar_Week')}
              </Select.Option>
              <Select.Option value={TimeType.Custom}>
                {getFormatMessage('custom_week')}
              </Select.Option>
            </Select>

            {weekType === TimeType.Custom && (
              <Select
                value={weekCustomType}
                style={{ width: 140, marginRight: 20 }}
                onChange={handleWeekCustomTypeChange}
              >
                <Select.Option value={CustomType.Inside}>
                  {getFormatMessage('current_week')}
                </Select.Option>
                <Select.Option value={CustomType.Astride}>
                  {getFormatMessage('cross_week')}
                </Select.Option>
              </Select>
            )}

            {weekType === TimeType.Custom &&
              weekCustomType === CustomType.Astride && (
                <span className="time-week-label">
                  {language === LanguageType.zh_CN ? '每' : ''}
                </span>
              )}
            {weekType === TimeType.Custom ? (
              <Select
                options={weekOptions.map((item) => {
                  return {
                    ...item,
                    disabled: weekStartDisabled(item.value),
                  };
                })}
                value={weekStartTime.week}
                onChange={(value) =>
                  setWeekStartTime({ ...weekStartTime, week: value })
                }
                virtual={false}
                style={{ width: 120, marginLeft: 8 }}
              />
            ) : (
              <span className="time-week-label">
                {getFormatMessage('monday')}
              </span>
            )}
            <InputNumber
              min={getHourMinNum('week', 'start')}
              max={getHourMaxNum('week', 'start')}
              formatter={formatter}
              value={weekStartTime.hour}
              onChange={(value) =>
                setWeekStartTime({ ...weekStartTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('week', 'start')}
              max={getMinuteMaxNum('week', 'start')}
              formatter={formatter}
              value={weekStartTime.minute}
              onChange={(value) =>
                setWeekStartTime({ ...weekStartTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('week', 'start')}
              max={getSecondMaxNum('week', 'start')}
              formatter={formatter}
              value={weekStartTime.second}
              onChange={(value) =>
                setWeekStartTime({ ...weekStartTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />

            <span className="time-week-time-label" style={{ margin: '0 8px' }}>
              {' '}
              -{' '}
            </span>

            {weekType === TimeType.Custom &&
              weekCustomType === CustomType.Astride && (
                <span className="time-week-label" style={{ marginLeft: 0 }}>
                  {getFormatMessage('time_next')}
                </span>
              )}
            {weekType === TimeType.Custom ? (
              <Select
                options={weekOptions.map((item) => {
                  return {
                    ...item,
                    disabled: weekEndDisabled(item.value),
                  };
                })}
                value={weekEndTime.week}
                onChange={(value) =>
                  setWeekEndTime({ ...weekEndTime, week: value })
                }
                virtual={false}
                style={{ width: 120, marginLeft: 8 }}
              />
            ) : (
              <span className="time-week-label">
                {getFormatMessage('sunday')}
              </span>
            )}
            <InputNumber
              min={getHourMinNum('week', 'end')}
              max={getHourMaxNum('week', 'end')}
              formatter={formatter}
              value={weekEndTime.hour}
              onChange={(value) =>
                setWeekEndTime({ ...weekEndTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('week', 'end')}
              max={getMinuteMaxNum('week', 'end')}
              formatter={formatter}
              value={weekEndTime.minute}
              onChange={(value) =>
                setWeekEndTime({ ...weekEndTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('week', 'end')}
              max={getSecondMaxNum('week', 'end')}
              formatter={formatter}
              value={weekEndTime.second}
              onChange={(value) =>
                setWeekEndTime({ ...weekEndTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />
          </div>
        ) : (
          <div className="tab-time-zone-box">{renderWeekText()}</div>
        )}
      </div>
      <div
        className={classNames(
          'tab-time-zone',
          isEditMonth ? 'tab-time-zone-edit' : ''
        )}
      >
        <div className="tab-time-zone-title">
          <div>{getFormatMessage('monthly_definition')}</div>
          {isEditMonth && (
            <div className="tab-time-zone-btn">
              <div
                className="tab-time-zone-save"
                onClick={() => handleEditOk(EditType.Mouth)}
              >
                {getFormatMessage('save')}
              </div>
              <div
                className="tab-time-zone-cancel"
                onClick={() => handleEditCancel(EditType.Mouth)}
              >
                {getFormatMessage('cancel')}
              </div>
            </div>
          )}
        </div>
        {isEditMonth ? (
          <div className="time-week-box">
            <Select
              value={mouthType}
              style={{ width: 150, marginRight: 20 }}
              onChange={handleMouthTypeChange}
            >
              <Select.Option value={TimeType.Natural}>
                {getFormatMessage('calendar_month')}
              </Select.Option>
              <Select.Option value={TimeType.Custom}>
                {getFormatMessage('custom_month')}
              </Select.Option>
            </Select>

            {mouthType === TimeType.Custom && (
              <Select
                value={mouthCustomType}
                style={{ width: 140, marginRight: 20 }}
                onChange={handleMouthCustomTypeChange}
              >
                <Select.Option value={CustomType.Inside}>
                  {getFormatMessage('time_current_month')}
                </Select.Option>
                <Select.Option value={CustomType.Astride}>
                  {getFormatMessage('cross_month')}
                </Select.Option>
              </Select>
            )}

            {mouthType === TimeType.Custom && (
              <span className="time-week-label">
                {language === LanguageType.zh_CN ? '每月' : ''}
              </span>
            )}
            {mouthType === TimeType.Custom ? (
              <Select
                options={mouthOptions.map((item) => {
                  return {
                    ...item,
                    disabled: mouthStartDisabled(item.value),
                  };
                })}
                value={mouthStartTime.day}
                onChange={(value) =>
                  setMouthStartTime({ ...mouthStartTime, day: value })
                }
                virtual={false}
                style={{ width: 74, marginLeft: 8 }}
              />
            ) : (
              <span className="time-week-label">{`1${getFormatMessage(
                'definition_st'
              )}`}</span>
            )}
            <InputNumber
              min={getHourMinNum('mouth', 'start')}
              max={getHourMaxNum('mouth', 'start')}
              formatter={formatter}
              value={mouthStartTime.hour}
              onChange={(value) =>
                setMouthStartTime({ ...mouthStartTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('mouth', 'start')}
              max={getMinuteMaxNum('mouth', 'start')}
              formatter={formatter}
              value={mouthStartTime.minute}
              onChange={(value) =>
                setMouthStartTime({ ...mouthStartTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('mouth', 'start')}
              max={getSecondMaxNum('mouth', 'start')}
              formatter={formatter}
              value={mouthStartTime.second}
              onChange={(value) =>
                setMouthStartTime({ ...mouthStartTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />

            <span className="time-week-time-label" style={{ margin: '0 8px' }}>
              {' '}
              -{' '}
            </span>

            {mouthType === TimeType.Custom && (
              <span className="time-week-label" style={{ marginLeft: 0 }}>
                {mouthCustomType === CustomType.Astride
                  ? getFormatMessage('next_monthly')
                  : getFormatMessage('current_monthly')}
              </span>
            )}
            {mouthType === TimeType.Custom ? (
              <Select
                options={mouthOptions.map((item) => {
                  return {
                    ...item,
                    disabled: mouthEndDisabled(item.value),
                  };
                })}
                value={mouthEndTime.day}
                onChange={(value) =>
                  setMouthEndTime({ ...mouthEndTime, day: value })
                }
                virtual={false}
                style={{ width: 74, marginLeft: 8 }}
              />
            ) : (
              <span className="time-week-label">{`31${getFormatMessage(
                'definition_st'
              )}`}</span>
            )}
            <InputNumber
              min={getHourMinNum('mouth', 'end')}
              max={getHourMaxNum('mouth', 'end')}
              formatter={formatter}
              value={mouthEndTime.hour}
              onChange={(value) =>
                setMouthEndTime({ ...mouthEndTime, hour: value || 0 })
              }
              style={{ width: 56, marginLeft: 8 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getMinuteMinNum('mouth', 'end')}
              max={getMinuteMaxNum('mouth', 'end')}
              formatter={formatter}
              value={mouthEndTime.minute}
              onChange={(value) =>
                setMouthEndTime({ ...mouthEndTime, minute: value || 0 })
              }
              style={{ width: 56 }}
            />
            <span className="time-week-time-label">:</span>
            <InputNumber
              min={getSecondMinNum('mouth', 'end')}
              max={getSecondMaxNum('mouth', 'end')}
              formatter={formatter}
              value={mouthEndTime.second}
              onChange={(value) =>
                setMouthEndTime({ ...mouthEndTime, second: value || 0 })
              }
              style={{ width: 56 }}
            />
          </div>
        ) : (
          <div className="tab-time-zone-box">{renderMouthText()}</div>
        )}
      </div>
      <div
        className={classNames(
          'tab-time-zone',
          isEditTimeZone ? 'tab-time-zone-edit' : ''
        )}
      >
        <div className="tab-time-zone-title">
          <div>{getFormatMessage('effective_time_zone')}</div>
          {isEditTimeZone && (
            <div className="tab-time-zone-btn">
              <div
                className="tab-time-zone-save"
                onClick={() => handleEditOk(EditType.TimeZone)}
              >
                {getFormatMessage('save')}
              </div>
              <div
                className="tab-time-zone-cancel"
                onClick={() => handleEditCancel(EditType.TimeZone)}
              >
                {getFormatMessage('cancel')}
              </div>
            </div>
          )}
        </div>
        {!isEditTimeZone && (
          <div className="tab-time-zone-desc">
            {getFormatMessage('effective_time_zone_Desc')}
          </div>
        )}
        {isEditTimeZone ? (
          <Select
            className="tab-time-zone-select"
            value={currentSelectedTimezone}
            options={filteredTimezones}
            dropdownRender={dropdownRender}
            onDropdownVisibleChange={handleDropdownVisibleChange}
            open={dropdownVisible}
          />
        ) : (
          <div className="tab-time-zone-box">{renderTimeText()}</div>
        )}
      </div>
    </div>
  );
};
